import algoliasearch from 'algoliasearch/lite';

const searchClient = algoliasearch('OSFICRI7IA', '9be081f0f0b11013d1a22c44e6f5460d');

export { searchClient };
